namespace Gordic.Epk.WebControls.Vyrizeni {


    //#region *** EPK CONFIG ***

    export class EpkConfig {

        /** soubor vyřízení DTO */
        private VyrizSouborDto: IVyrizSouborDto = {
            Filename: null,
            Guid: null,
            Ixp: null,
            TxtPopis: null,
            TxtTitulek: null
        }

        private server = new GContent("Gordic.Epk.WebControls.Vyrizeni");

        /**
         * zavolat serverovou metodu EpkCompleteConfig
         * 
         * @param {IVyrizeniEpkParams} params parametry
         * @param {string} [duvodVyrizeniTxt]
         * @param {any} 
         */
        public callEpkCompleteConfig(params: IVyrizeniEpkParams, async: boolean, duvodVyrizeniTxt?: string): JQuery.Promise<Gordic.Wfl.Interface.GEpkVyrizConfigGuidDto> {

            /** pokud je text důvodu vyřízení nedefinován, doplním aspoň prázdný string */
            duvodVyrizeniTxt = duvodVyrizeniTxt == null ? "" : duvodVyrizeniTxt;

            var opt: Wfl.Interface.GEpkCompleteConfigDto = {
                Ixp: params.ixp,
                SerCislo: params.serCislo,
                ZpusobVyrizeni: params.zpusobVyrizeni,
                TypPozadavku: params.typPozadavku,
                VyrizeniTxt: duvodVyrizeniTxt,
                IxsDpo: params.ixsDpo,
                CasRazitko: params.casoveRazitko,
                CasRazitkoPrilohy: params.casoveRazitkoPrilohy,
                PodepsatObraz: params.podepsatObraz,
                PodepsatPrilohy: params.podepsatPrilohy,
                PredPodepsanimKonvertovat: params.predPodepsanimKonvertovat,
                ZkonvertovatPrilohy: params.zkonvertovatPrilohy,
                PodepsatPrilohyNePdf: params.podepsatPrilohyNePdf,
                GuidGFRM: params.guidGFRM == null ? "" : params.guidGFRM
            };

            return this.epkCompleteConfig(opt, async, true);

        }

        /**
         * epkCompleteConfig
         */
        public epkCompleteConfig(dto: Wfl.Interface.GEpkCompleteConfigDto, async: boolean, multi: boolean): JQuery.Promise<Gordic.Wfl.Interface.GEpkVyrizConfigGuidDto> {


            // // TransferFile kvůli APG
            //that.server.call("TransferFile", { Guid: that.GuidConfig });

            var that = this;
            var dfd = $.Deferred();

            function syncCompleteConfig() {
                that.server.call("EpkCompleteConfig", dto)
                    .then((result) => {
                        dfd.resolve(result);
                    })
                    .fail((reason) => {
                        var responseText = handleException(reason, "EpkCompleteConfig", multi);
                        var rejectReason: IGReasonResponse = {
                            reason: responseText,
                            handled: true,
                            type: EReasonType.serverError,
                            operation: OperationsEnum.sign
                        }
                        dfd.reject(rejectReason);
                    })
            }

            function asyncCompleteConfig() {
                var task = Gordic.Async.GTaskManager.start<Gordic.Async.IGTaskProgress, Gordic.Wfl.Interface.GEpkVyrizConfigGuidDto>("Gordic.Wfl.Server.GEpkCompleteConfigAsyncTask", dto);
                task.getPromise()
                    .then((output) => {
                        Gordic.Async.GTaskManager.clean(task);
                        return output;
                    })
                    .then((output) => {
                        dfd.resolve(output.result);
                    }, (reason) => {

                        var response = handleExceptionAsync(reason, "EpkCompleteConfigAsync", multi);
                        var rejectReason: IGReasonResponse = {
                            reason: response.baseMessage,
                            //@ts-ignore
                            reasonlong: response.longMessage,
                            handled: true,
                            type: EReasonType.serverError,
                            operation: OperationsEnum.sign
                        }
                        dfd.reject(rejectReason);
                    })
            }

            if (async === true) {
                asyncCompleteConfig();
            }
            else {
                syncCompleteConfig();
            }

            return dfd.promise();
        }

        /**
         * zavolat finální EpkFinishSettlement
         * 
         * @param {IVyrizeniEpkParams} params parametry
         * @param {EpkVyrizeniResultDto[]} [data]
         */
        public callEpkFinishSettlement(gcontent: GContent<any>, params: IVyrizeniEpkParams, guidConfig?: string | null, data?: EpkVyrizeniResultDto[]) {

            var dfd = $.Deferred();

            var Files: EpkVyrizeniResultDto[] = data == null ? [] : data;
            var VyrizSouborDto = this.getVyrizSouborDto(gcontent);

            var Opt: Gordic.Wfl.Interface.GEpkFinishSettlementOptDto = {
                Ixp: params.ixp,
                SerCislo: params.serCislo,
                ZpusobVyrizeni: params.zpusobVyrizeni,
                TypPozadavku: params.typPozadavku,
                VyrizSouborDto: VyrizSouborDto === true ? this.VyrizSouborDto : null,
                Guid: guidConfig    // guid vyrizConfigu
            }

            var Input: Gordic.Wfl.Interface.GEpkFinishSettlementDto = {
                Files: Files,
                Opt: Opt
            };

            this.server.call("EpkFinishSettlement", { Input: Input })
                .then((response) => {
                    dfd.resolve(response);
                })
                .fail((reason) => {
                    var responseText = handleException(reason, "EpkFinishSettlement");
                    var rejectReason: IGReasonResponse = {
                        reason: responseText,
                        handled: true,
                        type: EReasonType.serverError,
                        operation: OperationsEnum.sign
                    }
                    dfd.reject(rejectReason);
                })

            return dfd.promise();
        }

        public callEpkFinishSettlementMulti(item: Wfl.Interface.GEpkCompleteConfigDto, guidConfig: string | null | undefined, data: EpkVyrizeniResultDto[] | null, async: boolean) {

            var that = this;
            var dfd = $.Deferred();

            var Files: EpkVyrizeniResultDto[] = data == null ? [] : data;
            var Opt: Gordic.Wfl.Interface.GEpkFinishSettlementOptDto = {
                Ixp: item.Ixp,
                SerCislo: item.SerCislo,
                ZpusobVyrizeni: item.ZpusobVyrizeni,
                TypPozadavku: item.TypPozadavku,
                VyrizSouborDto: null,               // info: nelze připojit vyřizující soubor
                Guid: guidConfig    
            }

            var Input: Gordic.Wfl.Interface.GEpkFinishSettlementDto = {
                Files: Files,
                Opt: Opt
            };

            function syncFinishSettlement() {
                that.server.call("EpkFinishSettlement", {
                    Input: Input
                })
                    .then(() => {
                        dfd.resolve(true);
                    })
                    .fail((reason) => {
                        var responseText = handleException(reason, "EpkFinishSettlement");
                        var rejectReason: IGReasonResponse = {
                            reason: responseText,
                            handled: true,
                            type: EReasonType.serverError,
                            operation: OperationsEnum.sign
                        }
                        dfd.reject(rejectReason);
                    })
            }

            function asyncFinishSettlement() {
                var task = Gordic.Async.GTaskManager.start<Gordic.Async.IGTaskProgress, any>("Gordic.Wfl.Server.GEpkFinishSettlementConfigAsyncTask", Input);
                task.getPromise()
                    .then(() => {
                        Gordic.Async.GTaskManager.clean(task);
                    })
                    .then(() => {
                        dfd.resolve(true);
                    }, (reason) => {
                        var response = handleExceptionAsync(reason, "EpkFinishSettlementAsync");
                        var rejectReason: IGReasonResponse = {
                            reason: response.baseMessage,
                            //@ts-ignore
                            reasonlong: response.longMessage,
                            handled: true,
                            type: EReasonType.serverError,
                            operation: OperationsEnum.sign
                        }
                        dfd.reject(rejectReason);
                    })
                return dfd.promise();
            }

            if (async === true) {
                asyncFinishSettlement();
            }
            else {
                syncFinishSettlement();
            }

            return dfd.promise();
        }

        /** zavolat EpkFinishSettlement pro ukrajinu */
        public callEpkFinishSettlementUkr(gcontent: GContent<any>, params: IVyrizeniEpkParams, data?: EpkVyrizeniResultDto[]) {

            var dfd = $.Deferred();

            /** název serverové metody */
            var serverName = "EpkFinishSettlementUkraine";
            // připojení souboru k vyřízení
            var VyrizSouborDto = this.getVyrizSouborDto(gcontent);

            /** nastavení options k vyřízení */
            var options: any = {
                data: data !== undefined ? data : null,
                Ixp: params.ixp,
                SerCislo: params.serCislo,
                ZpusobVyrizeni: params.zpusobVyrizeni,
                TypPozadavku: params.typPozadavku,
                VyrizSouborDto: VyrizSouborDto === true ? this.VyrizSouborDto : null
            }
            this.server.call(serverName, options)
                .then((response) => {
                    dfd.resolve(response);
                }, (reason) => {
                    var responseText = handleException(reason, "EpkFinishSettlementUkraine");
                    var rejectReason: IGReasonResponse = {
                        reason: responseText,
                        handled: true,
                        type: EReasonType.serverError,
                        operation: OperationsEnum.sign
                    }
                    dfd.reject(rejectReason);
                })

            return dfd.promise();
        }

        /**
         * seřadit configy, tak, aby byl první obraz a poté následovali přílohy
         * @param configs
         */
        public sortConfigs(configs?: Wfl.Interface.GEpkSignConfigDto[] | null) {

            if (configs == null)
                return configs;

            for (var index = 0; index < configs.length; index++) {
                // vybraný config
                var Config = configs[index];
                // typ dokumentu
                var ElDocumentType = Config.ElDocumentType;
                if (ElDocumentType === 0) {                                     // obraz el. dokumentu
                    // odstranění prvku el. dokumentu
                    configs.splice(index, 1);
                    // přidání configu na první místo
                    configs.unshift(Config);
                    break;
                }
            }
            return configs;
        }

        /**
         * získat dto přiloženého souboru
         */
        private getVyrizSouborDto(gcontent: any): boolean {
            if ((gcontent.fileInfo === undefined) || (gcontent.fileInfo.guid === "")) {
                return false;
            }
            else {
                this.VyrizSouborDto = {
                    Ixp: gcontent.Ixp,
                    Guid: gcontent.fileInfo.guid,
                    Filename: gcontent.fileInfo.filename,
                    TxtTitulek: gcontent.fileInfo.title,
                    TxtPopis: gcontent.fileInfo.description
                };
                return true;
            }
        }

    }

    //#endregion


}